import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        mobileMenu: false
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/infrastructure/store/store.js